import PropTypes from 'prop-types'
import React from 'react'

import Checkbox from 'components/Form/Checkbox'
import FormCollection from 'components/Form/Collection'
import Input from 'components/Form/Input'
import Select from 'components/Form/Select'
import Button from 'components/Button'
import classes from './EditType.scss'

import { makeOptions } from 'helpers/components'
import { guid } from 'helpers/index'

export const submitInputId = `submit-${guid()}`

export const EditType = (props) => (
  <form onSubmit={props.handleSubmit} className={classes['form']}>
    <input type='submit' id={submitInputId} className={classes.hidden} />

    <header className={classes['header']}>
      <div className={classes['header-title']}>
        Editing Type
        <span className={classes['header-title--unimportant']}> – {props.type.id}</span>
      </div>

      <div className={classes['header-buttons']}>
        <Button submit options={['green', 'small', 'desktop']}>
          Update
        </Button>

        <Button confirm options={['red', 'small']} callback={() => props.handleDelete(props.type.id)}>
          Delete
        </Button>
      </div>
    </header>

    <fieldset>
      <Input label='Name' placeholder='name' {...props.fields.name} />

      <Select label='Report (optional)'
        placeholder='select a report'
        selectOptions={[
          { value: 'shellfish', label: 'Shellfish' },
          { value: 'smallfish', label: 'Smallfish' }
        ]}
        {...props.fields.report}
      />

      <Checkbox
        label='Constrain Specs to Pricelist Availability'
        note='With this selected, only specs with prices on your pricelist will be available for order.'
        {...props.fields.constrain_options_to_pricelist}
      />

      <FormCollection
        label='UOMs'
        subLabel='If no UOMs are selected, all UOMs will be displayed.'
        collection={props.fields.uoms}
        defaultModel={{ id: undefined }}
        fields={[
          { name: 'id', element: 'select', selectOptions: makeOptions(props.uoms), placeholder: 'add a uom' }
        ]}
      />

      <FormCollection
        label='Specs'
        subLabel='If no specs are selected, specs will be hidden during order creation.  In other places, all specs will be shown.'
        collection={props.fields.options}
        defaultModel={{ id: undefined }}
        fields={[
          { name: 'id', element: 'select', selectOptions: makeOptions(props.options), placeholder: 'add a spec' }
        ]}
      />
    </fieldset>

    <fieldset>
      <div className={classes['legend--center']}>Binning</div>

      <Input label='Max Quantity per Bin' placeholder='quantity' pattern='[0-9]+(\.[0-9]{0,})?' {...props.fields.bin_max} />

      <Select label='Max Quantity UOM per Bin'
        subLabel={`If a UOM is selected, will only bin if the UOM matches, so 50oz won't split, but 50lb will.`}
        placeholder='select uom'
        selectOptions={makeOptions(props.uoms)}
        {...props.fields.bin_uom_id}
      />
    </fieldset>

    <footer className={classes['footer']}>
      <Button element={'label'} htmlFor={submitInputId} stick options={['green', 'block']}>
        Update Type
      </Button>
    </footer>
  </form>
)

EditType.propTypes = {
  type: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  uoms: PropTypes.array.isRequired,
  onSubmit: PropTypes.func, // actual submit function
  handleSubmit: PropTypes.func.isRequired, // redux-form function
  handleDelete: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired
}

export default EditType



// WEBPACK FOOTER //
// ./src/components/Types/Edit/EditType.js